import { FC, useMemo } from 'react';
import { WalletOutlined } from '@ant-design/icons';
import { PMSumBuyAndSellChartProps } from '../../../../../../core/domain/overview/pm-sum-buy-and-sell';
import { ChartCard } from '../../components/chart-card/chart-card';
import { AreaSeriesChart, CHART_COLORS, faNumber, mergeByDate, sumOf } from '../chart-commons';

interface Props {
    chartData: PMSumBuyAndSellChartProps;
    chartLoading: boolean;
}

const series = [
    { key: 'buys', name: 'خرید', color: CHART_COLORS.green },
    { key: 'sells', name: 'فروش', color: CHART_COLORS.red },
];

export const PMSumBuyAndSell: FC<Props> = ({ chartData, chartLoading }) => {
    const data = useMemo(
        () =>
            mergeByDate([
                { key: 'buys', data: chartData?.buys },
                { key: 'sells', data: chartData?.sells },
            ]),
        [chartData],
    );

    return (
        <ChartCard
            title="مجموع خرید و فروش های یو ووچر"
            subtitle="مبلغ سفارش‌های یو ووچر به تفکیک روز"
            icon={<WalletOutlined />}
            accent="amber"
            loading={chartLoading}
            empty={!data.length}
            stats={[
                { label: 'خرید', value: faNumber(sumOf(data, 'buys')), color: CHART_COLORS.green },
                { label: 'فروش', value: faNumber(sumOf(data, 'sells')), color: CHART_COLORS.red },
            ]}
        >
            <AreaSeriesChart data={data} series={series} />
        </ChartCard>
    );
};
